export default __webpack_public_path__ + "static/media/canada-flag.be440ff5.png";